













import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';

@Component
export default class HelloWord extends Vue {
  @Prop(Number) totals!: any;
  @Watch('totals', { deep: true })
  handchange(val) {
    this.total = val;
  }
  currentPage4: any = 1;
  total = 0;
  size = 10;
  handleSizeChange(val) {
    this.size = val;
    this.currentPage4 = 1;
    console.log(`每页 ${val} 条`);
    this.$emit('pagachange', this.currentPage4, val);
  }
  handleCurrentChange(val) {
    this.currentPage4 = val;
    this.$emit('pagachange', val, this.size);
    console.log(`当前页: ${val}`);
  }
}
